import type { ReactElement, ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'accent' | 'positive' | 'warning' | 'danger';

export function Badge({
  tone = 'neutral',
  children,
}: {
  tone?: BadgeTone;
  children: ReactNode;
}): ReactElement {
  return <span className={`badge${tone === 'neutral' ? '' : ` badge--${tone}`}`}>{children}</span>;
}
